// GET /api/search — powers the command palette. The palette UI itself ships
// in a later unit (this unit only stubs its topbar trigger); the typed
// wrapper is added now per the API contract.
import { apiFetch, toQuery } from './client';
import type { SearchResults } from '$lib/types';

export const searchApi = {
  query: (q: string) => apiFetch<SearchResults>(`/search${toQuery({ q })}`)
};
